
export const getOilfieldConfig: { [id: number]: oilfieldInfoType } = {
    0: {
        id: 0,
        name: "小型古井",
        spriteName: "oilfield0",
        /**描述 */
        tips: '',
        /**购买价格 */
        buyPrice: 1000000,
        /**出现金矿列表 */
        hasOildielKengIDList: [0, 1, 7],
        /**出现金矿权重列表 */
        hasOildielKengWeightIDList: [20, 50, 30],
        /**出现物品列表 */
        hasOilfieldSpecialList: [0, 2, 6, 7, 8],
        //清空、+10万、+300万、+50万、+500万崆峒镜
        /**出现金矿概率列表 */
        hasOilfieldSpecialWeightList: [40, 40, 5, 10, 5]

    },
    1: {
        id: 1,
        name: "小型古井",
        spriteName: "oilfield1",
        /**描述 */
        tips: '',
        /**购买价格 */
        buyPrice: 2000000,
        /**出现金矿列表 */
        hasOildielKengIDList: [0, 1, 2, 3, 4, 7],
        /**出现金矿权重列表 */
        hasOildielKengWeightIDList: [30, 15, 15, 15, 5, 20],
        /**出现物品列表 */
        hasOilfieldSpecialList: [0, 2, 6, 7, 8],
        //清空、+10万、+300万、+50万、+500万崆峒镜
        /**出现金矿概率列表 */
        hasOilfieldSpecialWeightList: [45, 30, 10, 10, 5]

    },
    2: {
        id: 2,
        name: "小型古井",
        spriteName: "oilfield2",
        /**描述 */
        tips: '',
        /**购买价格 */
        buyPrice: 4000000,
        /**出现金矿列表 */
        hasOildielKengIDList: [2, 3, 4, 5, 7],
        /**出现金矿权重列表 */
        hasOildielKengWeightIDList: [30, 25, 10, 5, 30],
        /**出现物品列表 */
        hasOilfieldSpecialList: [0, 1, 2, 3, 6, 9],
        //清空、-1000万、+10万、+500万、+50万、+300万、+500万崆峒镜
        /**出现金矿概率列表 */
        hasOilfieldSpecialWeightList: [20, 10, 40, 5, 20, 5]

    },
    3: {
        id: 3,
        name: "中型古井",
        spriteName: "oilfield3",
        /**描述 */
        tips: '',
        /**购买价格 */
        buyPrice: 8000000,
        /**出现金矿列表 */
        hasOildielKengIDList: [2, 3, 4, 5, 6, 7, 8, 9],
        /**出现金矿权重列表 */
        hasOildielKengWeightIDList: [20, 30, 10, 5, 5, 20, 5, 5],
        /**出现物品列表 */
        hasOilfieldSpecialList: [0, 2, 3, 5, 6, 9],
        //清空、-1000万、+10万、+500万、-1000万、+50万、+300万、+500万崆峒镜
        /**出现金矿概率列表 */
        hasOilfieldSpecialWeightList: [20, 30, 15, 15, 15, 5]

    },
    4: {
        id: 4,
        name: "中型古井",
        spriteName: "oilfield4",
        /**描述 */
        tips: '',
        /**购买价格 */
        buyPrice: 10000000,
        /**出现金矿列表 */
        hasOildielKengIDList: [3, 4, 5, 6, 7, 8, 9],
        /**出现金矿权重列表 */
        hasOildielKengWeightIDList: [10, 20, 10, 5, 35, 10, 10],
        /**出现物品列表 */
        hasOilfieldSpecialList: [0, 1, 3, 5, 6, 10],
        //清空、-1000万、+10万、+500万、1000万、-1000万、+50万、+300万、+500万崆峒镜
        /**出现金矿概率列表 */
        hasOilfieldSpecialWeightList: [20, 15, 40, 10, 10, 5]
    },
    5: {
        id: 5,
        name: "大型古井",
        spriteName: "oilfield5",
        /**描述 */
        tips: '',
        /**购买价格 */
        buyPrice: 30000000,
        /**出现金矿列表 */
        hasOildielKengIDList: [4, 5, 6, 7, 8, 9],
        /**出现金矿权重列表 */
        hasOildielKengWeightIDList: [5, 30, 40, 5, 10, 10],
        /**出现物品列表 */
        hasOilfieldSpecialList: [ 1, 2, 4, 5, 7, 11],
        //清空、-1000万、+10万、+500万、1000万、-1000万、+50万、+300万、+500万崆峒镜
        /**出现金矿概率列表 */
        hasOilfieldSpecialWeightList: [ 20, 15, 30, 10,  20, 5]
    }
}

export const getOilfieldConfigH5: { [id: number]: oilfieldInfoType } = {
    0: {
        id: 0,
        name: "小型古井",
        spriteName: "oilfield0",
        /**描述 */
        tips: '',
        /**购买价格 */
        buyPrice: 1000000,
        /**出现金矿列表 */
        hasOildielKengIDList: [0, 1, 7],
        /**出现金矿权重列表 */
        hasOildielKengWeightIDList: [20, 50, 30],
        /**出现物品列表 */
        hasOilfieldSpecialList: [0, 2, 6, 7, 8],
        //清空、+10万、+300万、+50万、+500万崆峒镜
        /**出现金矿概率列表 */
        hasOilfieldSpecialWeightList: [40, 40, 5, 10, 50]

    },
    1: {
        id: 1,
        name: "小型古井",
        spriteName: "oilfield1",
        /**描述 */
        tips: '',
        /**购买价格 */
        buyPrice: 2000000,
        /**出现金矿列表 */
        hasOildielKengIDList: [0, 1, 2, 3, 4, 7],
        /**出现金矿权重列表 */
        hasOildielKengWeightIDList: [30, 15, 15, 15, 5, 20],
        /**出现物品列表 */
        hasOilfieldSpecialList: [0, 2, 6, 7, 8],
        //清空、+10万、+300万、+50万、+500万崆峒镜
        /**出现金矿概率列表 */
        hasOilfieldSpecialWeightList: [45, 30, 10, 10, 50]

    },
    2: {
        id: 2,
        name: "小型古井",
        spriteName: "oilfield2",
        /**描述 */
        tips: '',
        /**购买价格 */
        buyPrice: 4000000,
        /**出现金矿列表 */
        hasOildielKengIDList: [2, 3, 4, 5, 7],
        /**出现金矿权重列表 */
        hasOildielKengWeightIDList: [30, 25, 10, 5, 30],
        /**出现物品列表 */
        hasOilfieldSpecialList: [0, 1, 2, 3, 6, 9],
        //清空、-1000万、+10万、+500万、+50万、+300万、+500万崆峒镜
        /**出现金矿概率列表 */
        hasOilfieldSpecialWeightList: [20, 10, 20, 5, 20, 50]

    },
    3: {
        id: 3,
        name: "中型古井",
        spriteName: "oilfield3",
        /**描述 */
        tips: '',
        /**购买价格 */
        buyPrice: 8000000,
        /**出现金矿列表 */
        hasOildielKengIDList: [2, 3, 4, 5, 6, 7, 8, 9],
        /**出现金矿权重列表 */
        hasOildielKengWeightIDList: [20, 30, 10, 5, 5, 20, 5, 5],
        /**出现物品列表 */
        hasOilfieldSpecialList: [0, 2, 3, 5, 6, 9],
        //清空、-1000万、+10万、+500万、-1000万、+50万、+300万、+500万崆峒镜
        /**出现金矿概率列表 */
        hasOilfieldSpecialWeightList: [20, 15, 15, 10, 15, 50]

    },
    4: {
        id: 4,
        name: "中型古井",
        spriteName: "oilfield4",
        /**描述 */
        tips: '',
        /**购买价格 */
        buyPrice: 10000000,
        /**出现金矿列表 */
        hasOildielKengIDList: [3, 4, 5, 6, 7, 8, 9],
        /**出现金矿权重列表 */
        hasOildielKengWeightIDList: [10, 20, 10, 5, 35, 10, 10],
        /**出现物品列表 */
        hasOilfieldSpecialList: [0, 1, 3, 5, 6, 10],
        //清空、-1000万、+10万、+500万、1000万、-1000万、+50万、+300万、+500万崆峒镜
        /**出现金矿概率列表 */
        hasOilfieldSpecialWeightList: [15, 10, 15, 10, 10, 50]
    },
    5: {
        id: 5,
        name: "大型古井",
        spriteName: "oilfield5",
        /**描述 */
        tips: '',
        /**购买价格 */
        buyPrice: 30000000,
        /**出现金矿列表 */
        hasOildielKengIDList: [4, 5, 6, 7, 8, 9],
        /**出现金矿权重列表 */
        hasOildielKengWeightIDList: [5, 30, 40, 5, 10, 10],
        /**出现物品列表 */
        hasOilfieldSpecialList: [ 1, 2, 4, 5, 7, 11],
        //清空、-1000万、+10万、+500万、1000万、-1000万、+50万、+300万、+500万崆峒镜
        /**出现金矿概率列表 */
        hasOilfieldSpecialWeightList: [ 10, 15, 10, 10,  10, 50]
    }
}
export const oilPrefabPATH = "prefab/oilPrefab/"
export const getOilfieldKengConfig: { [id: number]: oilfieldKengDataType } = {
    0: {
        id: 0,
        name: "无矿",
        tips: "黑到家了，没看到一丁点金矿，开采用的花费都捞不回来，获得安慰奖10万",
        getMoney: 100000,
        showPrefabPathList: [],
        showPrefabWeightList: []
    },
    1: {
        id: 1,
        name: "超小型金矿",
        tips: "发现超小型金矿，金矿少的可怜，勉强能卖200多万",
        getMoney: 2480000,
        showPrefabPathList: ["oil111"],
        showPrefabWeightList: [1]
    },
    2: {
        id: 2,
        name: "微小型金矿",
        tips: "发现微小型金矿，矿量勉勉强强，预计能卖300万",
        getMoney: 3000000,
        showPrefabPathList: ["oil121", "oil211"],
        showPrefabWeightList: [1, 1]
    },
    3: {
        id: 3,
        name: "小型金矿",
        tips: "发现小型金矿，价值500万！",
        getMoney: 5000000,
        showPrefabPathList: ["oil311", "oil113"],
        showPrefabWeightList: [1, 1]
    },
    4: {
        id: 4,
        name: "中型金矿",
        tips: "发现中型金矿，价值1000万",
        getMoney: 10000000,
        showPrefabPathList: ["oil114", "oil411"],
        showPrefabWeightList: [1, 1]
    },
    5: {
        id: 5,
        name: "大型金矿",
        tips: "欧皇降世！发现了大型金矿，2000万到手了",
        getMoney: 20000000,
        showPrefabPathList: ["oil144", "oil414"],
        showPrefabWeightList: [1, 1]
    },
    6: {
        id: 6,
        name: "超大型金矿",
        tips: "欧皇降世！发现了超大型金矿，5000万到手了，一辈子不用愁了",
        getMoney: 50000000,
        showPrefabPathList: ["oil244", "oil444", "oil424"],
        showPrefabWeightList: [1, 1, 1]
    },
    7: {
        id: 7,
        name: "粪坑",
        tips: "发现了庞大的动物粪坑，粪运不错，被农场以20万元收购",
        getMoney: 200000,
        showPrefabPathList: ["oil444_fen"],
        showPrefabWeightList: [1]
    },
    8: {
        id: 8,
        name: "鸭马蝶化石",
        tips: "发现了远古时期的鸭子、马、蝴蝶的混合物种，已被博物馆以4000万收藏！",
        getMoney: 40000000,
        showPrefabPathList: ["oil555"],
        showPrefabWeightList: [1]
    },
    9: {
        id: 9,
        name: "澳特漫化石",
        tips: "你无意中发现了肥胖澳特漫典藏版，这可是史无前10例的发现啊！",
        getMoney: 12000000,
        showPrefabPathList: ["oil666"],
        showPrefabWeightList: [1]
    }
}
export const SpecialPrefabPATH = "prefab/specialPrefab/"
export const getOilfieldSpecialConfig: { [id: number]: oilfieldSpecialType } = {
    0: {
        id: 0,
        eventName: "炸弹",
        eventSpritePath: "oilSpecial0",
        itemName: "炸弹",
        itemSpritePath: "",
        tips: "你挖到了炸弹，整个金矿瞬间被炸的一干二净",
        prefabPath: "special0"
    },
    1: {
        id: 1,
        eventName: "远古生物群",
        eventSpritePath: "oilSpecial1",
        itemName: "真菌群落1",
        itemSpritePath: "",
        tips: "遭受了地底远古真菌群落的攻击，虽然逃过一劫，但是开采器材全部丢失，损失1000万",
        getMoney: -10000000,
        prefabPath: "special1"
    },
    2: {
        id: 2,
        eventName: "新物种",
        eventSpritePath: "oilSpecial2",
        itemName: "真菌群落2",
        itemSpritePath: "",
        tips: "在开采过程中竟然发现了一种新真菌物种，上报官府被奖励10万，后面被命名为基尼肽霉",
        getMoney: 100000,//10万
        prefabPath: "special2"
    },
    3: {
        id: 3,
        eventName: "新物种",
        eventSpritePath: "oilSpecial3",
        itemName: "藤蔓",
        itemSpritePath: "",
        tips: "在开采过程中竟然发现了一种新植物物种，上报官府被奖励500万，后面被命名为麻花藤",
        getMoney: 5000000,//500万
        prefabPath: "special3"
    },
    4: {
        id: 4,
        eventName: "宝箱",
        eventSpritePath: "oilSpecial4",
        itemName: "宝箱",
        itemSpritePath: "",
        tips: "在开采过程中竟然发现了宝箱，里面可能是某个时期的古人藏在此处的，看来有可以赚一笔",
        getMoney: 10000000,//1000万
        prefabPath: "special4"
    },
    5: {
        id: 5,
        eventName: "棺木",
        eventSpritePath: "oilSpecial5",
        itemName: "棺木",
        itemSpritePath: "",
        tips: "你故意挖到了棺木，原本要你赔偿10个亿，但是念你是第一次，就惩罚你1千万算了",
        getMoney: -10000000,//扣1000万
        prefabPath: "special5"
    },
    6: {
        id: 6,
        eventName: "黑珍珠",
        eventSpritePath: "oilSpecial6",
        itemName: "黑珍珠",
        itemSpritePath: "",
        tips: "罕见之物，可能是上个世纪大陆板块移动前，这里是一片汪洋",
        getMoney: 3000000,//300万
        prefabPath: "special6"
    },
    7: {
        id: 7,
        eventName: "青花陶瓷",
        eventSpritePath: "oilSpecial7",
        itemName: "青花陶瓷",
        itemSpritePath: "",
        tips: "开采时你发现了，青花瓷沐浴露瓶，这应该是哪个贵妃使用过的。砖家们抢着收藏。",
        getMoney: 500000,//50万
        prefabPath: "special7"
    },
    8: {
        id: 8,
        eventName: "崆峒镜碎片(一)",
        eventSpritePath: "",
        itemName: "崆峒镜碎片<一>",
        itemSpritePath: "",
        tips: "神秘的翠绿水晶镜碎片之一，上古传说此镜重现之日，将时空扭曲，能打开异世界的通往之门",
        getMoney: 5000000,//500万
        prefabPath: "special4",
        goodsId: 50032,
    },
    9: {
        id: 9,
        eventName: "崆峒镜碎片<二>",
        eventSpritePath: "",
        itemName: "崆峒镜碎片<二>",
        itemSpritePath: "",
        tips: "神秘的翠绿水晶镜碎片之一，上古传说此镜重现之日，将时空扭曲，能打开异世界的通往之门",
        getMoney: 5000000,//500万
        prefabPath: "special4",
        goodsId: 50033,
    },
    10: {
        id: 10,
        eventName: "崆峒镜碎片<三>",
        eventSpritePath: "oilSpecial6",
        itemName: "崆峒镜碎片<三>",
        itemSpritePath: "",
        tips: "神秘的翠绿水晶镜碎片之一，上古传说此镜重现之日，将时空扭曲，能打开异世界的通往之门",
        getMoney: 5000000,//500万
        prefabPath: "special4",
        goodsId: 50034,
    },
    11: {
        id: 11,
        eventName: "崆峒镜碎片<四>",
        eventSpritePath: "oilSpecial7",
        itemName: "崆峒镜碎片<四>",
        itemSpritePath: "",
        tips: "神秘的翠绿水晶镜碎片之一，上古传说此镜重现之日，将时空扭曲，能打开异世界的通往之门",
        getMoney: 5000000,//500万
        prefabPath: "special4",
        goodsId: 50035,
    }
}
/**特殊事件*/
export interface oilfieldSpecialType {
    /**ID */
    id: number,
    /**事件名称 */
    eventName: string,
    /**事件图片 */
    eventSpritePath: string,
    /**物品名称 */
    itemName: string,
    /**物品图片 */
    itemSpritePath: string,
    /**物品描述 */
    tips: string,
    /**获取金钱 */
    getMoney?: number,
    /**预制体路径 */
    prefabPath: string
    /** 物品id */
    goodsId?: number,

}
/**金矿属性 */
export interface oilfieldKengDataType {
    /**ID */
    id: number,
    /**名称 */
    name: string,
    /**描述 */
    tips: string
    /**获取价格 */
    getMoney: number,
    /**可选预制体列表 */
    showPrefabPathList: string[],
    /**可选预制体权重列表 */
    showPrefabWeightList: number[],
}
export interface oilfieldInfoType {
    /**ID */
    id: number,
    /**名称 */
    name: string,
    /**描述 */
    tips: string
    /**图片名称 */
    spriteName: string
    /**购买价格 */
    buyPrice: number,
    /**出现金矿列表 */
    hasOildielKengIDList: number[]
    /**出现金矿权重列表 */
    hasOildielKengWeightIDList: number[]
    /**出现物品列表 */
    hasOilfieldSpecialList: number[]
    /**出现金矿权重列表 */
    hasOilfieldSpecialWeightList: number[]
}   